var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "novice-tutorial-container" }, [
    _c("div", { staticClass: "novice-tutorial" }, [
      _c("h1", [_vm._v("锁定案源详细攻略")]),
      _c("p", [_vm._v("点击下方视频立即查看")]),
      _c(
        "div",
        { staticClass: "video-container" },
        [
          _vm.videoUrl
            ? _c("Video", {
                staticClass: "viode",
                attrs: { "video-url": _vm.videoUrl, poster: _vm.posterUrl }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/imgs/novice-tutorial/img@2x.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }